import { render, staticRenderFns } from "./BaseBackoffice.vue?vue&type=template&id=198c42ba&"
import script from "./BaseBackoffice.vue?vue&type=script&lang=js&"
export * from "./BaseBackoffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports